import ScrollableBlock from 'components/ScrollableBlock/ScrollableBlock'

import styles from './RewardsList.module.scss'

const RewardsList = ({ scrollableContentNodeRef, children }) => {
    return (
        <ScrollableBlock scrollableNodeRef={scrollableContentNodeRef}>
            <ul className={styles.rewardsList}>{children}</ul>
        </ScrollableBlock>
    )
}

export default RewardsList
